import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { cx } from '../../../../util/classname.js';
import { selectToken } from '../../../../util/tokenSelector.js';

var _excluded = ["borderRadius", "p", "title", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useInteractiveListItem = function useInteractiveListItem(props, theme) {
  var borderRadius = props.borderRadius,
    p = props.p,
    title = props.title,
    disabled = props.disabled,
    rest = _objectWithoutProperties(props, _excluded);
  var spacing = selectToken(theme.spacing, p);
  var radius = theme.radius[borderRadius];
  var className = cx(['list-item', disabled ? undefined : 'list-item-interactive']);
  var productPrimaryColorToken = selectToken(theme.text, 'product.primary');
  var hoverColor = "".concat(productPrimaryColorToken, "14"); // 8% opacity
  var focusColor = "".concat(productPrimaryColorToken, "1F"); // 12% opacity
  var pressedColor = "".concat(productPrimaryColorToken, "29"); // 16% opacity

  var isListItemV2Props = title !== undefined;
  var filter;
  if (isListItemV2Props) filter = undefined;else filter = disabled ? 'grayscale(100%)' : 'none';
  var style = {
    filter: filter,
    cursor: disabled ? 'not-allowed' : 'pointer',
    pointerEvents: disabled ? 'none' : 'auto',
    '--list-item-radius': radius,
    '--list-item-spacing': spacing,
    '--list-hover-color': "".concat(hoverColor),
    '--list-focus-color': "".concat(focusColor),
    '--list-pressed-color': "".concat(pressedColor)
  };
  return _objectSpread({
    className: className,
    style: style
  }, rest);
};

export { useInteractiveListItem };
//# sourceMappingURL=useInteractiveListItem.js.map
